import * as React from 'react';

import { cn, IconButton } from '@rematter/ui-web';
import { Trash2 } from 'lucide-react';

export interface DeleteButtonCellProps {
  onDelete?: () => void;
  disabled?: boolean;
  className?: string;
}

export const DeleteButtonCell: React.FC<DeleteButtonCellProps> = ({
  onDelete,
  disabled = false,
  className,
}) => (
  <IconButton
    icon={<Trash2 size={18} />}
    className={cn('@DeleteButtonCell', 'size-[40px]', className)}
    isDisabled={disabled}
    variant="ghost"
    color="failure"
    onPress={onDelete}
    aria-label="Delete line item"
  />
);
